import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

function Stats(props) {
  return (
    <div className="stat-list">
      <span className="title">{props.title}</span>
      {props.items.map((stat, index) => {
          return (<div className="stat-item" key={index}>
            <span className="count">{stat.count}</span>
            <span className="name">{stat.name}</span>
          </div>);
        })}
      </div>
  );
}

Stats.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string
};

const Statistics = ({ isFetching, statistics, isAppraiserManager, isCustomerService }) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  return (
    <Card className="md-cell md-cell--4">
      <CardContent><Typography variant="h6">{` ${isCustomerService ? "Customer Service Stats" : `Appraiser ${isAppraiserManager ? "Manager" : ""} Stats`}`}</Typography></CardContent>
      <CardContent>
        {isAppraiserManager
          ? <Stats items={statistics.managerStatus} />
          : <Stats items={statistics.appraiserStatus} />
        }
      </CardContent>
    </Card>
  );
};

Statistics.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  statistics: PropTypes.object.isRequired,
  isAppraiserManager: PropTypes.bool.isRequired,
  isCustomerService: PropTypes.bool,
};

export default Statistics;